module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view/auth/restore/restore.component.css
// module id = ./src/app/view/auth/restore/restore.component.css
// module chunks = main